import { Component, Prop, State, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-dropdown',
  styleUrls: ['../../global/input.css', '../../global/global.css'],
  shadow: false,
})
export class DdaDropdown {
  @Prop() label: string;
  @Prop() options: string; // Receive options as a string
  @Prop() selected: string;
  @Prop() disabled: boolean = false;
  @Prop() error: string;
  @Prop() helper_text: string;
  @Prop() type: 'bg-transparent' | 'bg-white' = 'bg-white';
  @Prop() size: 'small' | 'medium' = 'medium';
  @Prop() icon_mode: boolean = false; // New prop for icon mode
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 
  @Prop() button_id: string;
  @Prop() aria_label?: string;
  
  @State() isopen: boolean = false;

  private get parsedOptions(): string[] {
    try {
      return JSON.parse(this.options);
    } catch {
      return [];
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.isopen = !this.isopen;
    }
  }

  selectOption(option: string) {
    if (!this.disabled) {
      this.selected = option;
      this.isopen = false;
    }
  }

  render() {  
    const containerClass = [
      'dda-input-container dda-inline-flex',
      this.disabled ? 'dda-input-disabled' : '',
      this.size ? `dda-input-size-${this.size}` : '',
      this.custom_class ? `${this.custom_class}` : '',
      this.component_mode,
    ].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={containerClass}>
          {this.label && <label htmlFor={this.button_id} class="dda-input-label">{this.label}</label>}
          <div class={`dda-dropdown-container ${this.type}`}>
            <button id={this.button_id} aria-label={this.aria_label} type="button" class="dda-input-field dda-dropdown-header" onClick={() => this.toggleDropdown()}>
              <i class={`three-dots fa ${this.isopen ? 'fa-ellipsis-h' : 'fa-ellipsis-h'}`}></i>
              {!this.icon_mode && <span class="dda-dropdown-text"><span>{this.selected || 'Select an option'}</span> <i class={`fa ${this.isopen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i></span>
              }
            </button>
            {this.isopen && (
              <div class="dda-input-dropdown-list">
                {this.parsedOptions.length > 0 ? (
                  this.parsedOptions.map(option => (
                    <button type="button"
                      class={`dda-input-dropdown-item ${this.selected === option ? 'selected' : ''}`}
                      onClick={() => {this.selectOption(option)}}
                    >
                      {option}
                    </button>
                  ))
                ) : (
                  <div class="dda-input-dropdown-item">No options available</div>
                )}
              </div>
            )}
          </div>
          {this.helper_text && <span class="dda-helper-text">{this.helper_text}</span>}
          {this.error && <span class="dda-error-message">{this.error}</span>}
        </div>
      </Host>
    );
  }
}
